var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 520,
    viewBox: "0 0 360 520",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gzoom",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8e44ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c0392b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 520,
    fill: "url(#gzoom)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 260,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 260,
    r: 80
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 260,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 260,
    r: 160
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.38c42219e3ad81c36fcf42ec31aef047.svg";
export { ForwardRef as ReactComponent };